import * as React from "react";
import type { SVGProps } from "react";
const SvgGlobe01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M21 13a1 1 0 1 0 0-2v2m.6-1h-1a8.6 8.6 0 0 1-8.6 8.6v2c5.854 0 10.6-4.746 10.6-10.6zM12 21.6v-1A8.6 8.6 0 0 1 3.4 12h-2c0 5.854 4.746 10.6 10.6 10.6zM2.4 12h1A8.6 8.6 0 0 1 12 3.4v-2C6.146 1.4 1.4 6.146 1.4 12zM12 2.4v1a8.6 8.6 0 0 1 8.6 8.6h2c0-5.854-4.746-10.6-10.6-10.6zm0 19.2v-1c-.249 0-.565-.111-.94-.473-.38-.367-.767-.946-1.114-1.74C9.254 16.804 8.8 14.547 8.8 12h-2c0 2.755.487 5.298 1.314 7.189.413.944.93 1.77 1.556 2.375.63.61 1.42 1.036 2.33 1.036zM7.8 12h1c0-2.546.454-4.804 1.146-6.387.347-.794.735-1.373 1.114-1.74.375-.362.691-.473.94-.473v-2c-.91 0-1.7.426-2.33 1.035-.625.605-1.143 1.432-1.556 2.376C7.287 6.702 6.8 9.244 6.8 12zm4.2 9.6v1c.91 0 1.7-.426 2.33-1.036.625-.604 1.143-1.43 1.556-2.375.827-1.891 1.314-4.433 1.314-7.189h-2c0 2.546-.453 4.804-1.146 6.387-.347.794-.735 1.373-1.114 1.74-.375.362-.69.473-.94.473zm4.2-9.6h1c0-2.756-.487-5.298-1.314-7.189-.413-.944-.93-1.77-1.556-2.376C13.7 1.826 12.91 1.4 12 1.4v2c.25 0 .565.111.94.473.38.367.767.946 1.114 1.74C14.746 7.196 15.2 9.453 15.2 12zM2.4 12v1H21v-2H2.4z"
    />
  </svg>
);
export default SvgGlobe01;
